<template>
  <div class="mx-4">
    <div
      class="row py-4 border-bottom min-vh-70 d-flex flex-column flex-md-row"
    >
      <div class="col">
        <div class="d-flex justify-content-start align-items-center">
          <icon-view
            class="w-auto"
            icon="fa fa-tasks-alt"
            icon-background="#fff"
            icon-color="#F3AA1C"
            variant="icon-view-size"
          />
          <span class="color-black-1' font-18 font-weight-bold">
            {{ $t('LetterofAuthorization') }}
          </span>
        </div>
      </div>
      <div class="col d-flex justify-content-end mr-3">
        <action-button
          :text="$t('GoBack')"
          class="warning outline-warning px-4 py-2 mr-2"
          i="fa fa-arrow-circle-left"
          @click="goToHomeHandler"
        />
        <action-button
          :text="$t('printLetter')"
          class="btn-warning px-4 py-2 mx-2"
          i="fa fa-print"
          @click="onSubmitRequestHandler"
        />
        <action-button
          :text="$t('Save')"
          class="btn-success px-4 py-2 mr-2 mx-2"
          i="fa fa-save"
          @click="onSaveHandler"
        />
      </div>
    </div>
    <div class="row py-4 pl-4">
      <div class="col-md-12">
        <div class="font-14 font-weight-bold">
          <span class="color-orange-light-2 mr-2">
            REDACCION DE CARTA
            <span class="align-sub">* * *</span>
          </span>
          <span class="color-dark-blue">
            ESPECIFIQUE Y DESGLOSE LOS OBJETIVOS DE SU INVESTIGACIÓN, EL TIPO DE
            METODOLOGÍA Y MUESTRA
          </span>
        </div>
      </div>
      <div class="col-12 pt-4">
        <!-- cHECKBOX WITH Para poder editar el contenido de la carta es necesario que deshabilite la confirmación de la misma-->
        <checkbox
          text="Para poder editar el contenido de la carta es necesario que deshabilite la confirmación de la misma"
          class="checkbox__extended d-flex"
          v-model="enabled"
          :value="enabled"
        />
      </div>
    </div>
    <div class="row py-4 mx-2">
      <!-- Text Asunto y Text Area Contenido-->
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12">
            <custom-input
              :label="$t('Subject')"
              class="w-100 font-weight-bold color-dark-blue"
              :disabled="!this.isReadOnly"
            />
          </div>
          <div class="col-md-12 mt-4">
            <!-- <custom-input :label="$t('Content')" class="w-100 font-weight-bold color-dark-blue" /> -->
            <span class="font-16 font-weight-bold">
              <span class="color-dark-blue">
                {{ $t('Content') }}
              </span>
            </span>
            <VueEditor v-model="content" :disabled="!this.isReadOnly"
              :editorToolbar="customToolbar" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//components
import Checkbox from 'CheckBox';
import CustomInput from 'CustomInput';
import { VueEditor } from 'vue2-editor';

//services
import {
  getRequest as _getRequest,
  submitRequest as _submitRequest,
  submitAuthorizationLetter as _submitAuthorizationLetter,
} from '@/services/app.api.js';
import { i18n } from '@/i18n';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';
//vuex types
import types from '@/store/modules/app/types.js';

export default {
  name: 'AuthorizationLetter',
  mixins: [alertMixin],
  components: {
    Checkbox,
    CustomInput,
    VueEditor,
  },
  watch: {},
  data: () => ({
    tabId: null,
    requestInfo: {},
    enabled: true,
    content:
      '<p><strong>ESPECIFIQUE Y DESGLOSE</strong></p><p><br></p><p><strong>LOS OBJETIVOS DE SU INVESTIGACIÓN,</strong></p><p><br></p><p><strong>EL TIPO DE METODOLOGÍA Y MUESTRA.</strong></p>',
    subject: '',
    // Toolbar con opciones compatibles con SSRS HTML rendering
    customToolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }],
      [{ color: [] }],
      ['clean'],
    ],
  }),
  computed: {
    businessId() {
      return this.$route.params.businessId;
    },
    isReadOnly() {
      return !this.enabled;
    },
  },
  async mounted() {
    await this.getRequestInfo();

    //Set default text when the component is load and doesn't have any content
  },
  methods: {
    async getRequestInfo() {
      if (this.businessId) {
        this.requestInfo = (await _getRequest(this.businessId)).data;
        this.initializeSitemapInfo();
        this[types.SET_ITEM_MODEL](this.requestInfo);
      }
      //Get Authorization Letter saved
    },
    initializeSitemapInfo() {
      this[types.SET_SITEMAP_INFO]({
        routes: [
          i18n.t('Home'),
          `${i18n.t('ApplicationHeader.HeaderText')} #${this.businessId}`,
        ],
        request: {
          requestStatusId: this.requestInfo?.requestStatusId,
          requestStatusName: this.requestInfo?.requestStatusName,
          requestNumber: this.requestInfo?.requestNumber,
        },
      });
    },
    goToHomeHandler() {
      this.$router.replace('/');
    },
    //Save the authorization letter
    async onSaveHandler() {
      const isValid = await this.validateAllSteps();
      if (!isValid) return;
      var payload = {
        itemId: this.businessId,
        body: this.content,
        subject: this.subject,
        isCompleted: this.enabled,
      };
      let saveResponse = await this.submitAuthorizationLetter(payload).catch(
        (error) => {
          this.ShowToast('', error.response.data.message, 'error');
        }
      );

      if (saveResponse) {
        this.ShowToast(
          'Proceso exitoso',
          'El caso ha sido actualizado exitosamente.',
          'success'
        );
        await this.getRequestInfo();
      }
    },

    async onRefreshHandler() {
      await this.getRequestInfo();
    },
    // async onDownloadRequestReportHandler() {
    //   if (this.businessId) {
    //     const response = await getInvestigationRequestReport(
    //       this.businessId,
    //       this.isEnLang
    //     ).catch((error) => {
    //       this.ShowToast('', error.response.data.message, 'error');
    //     });
    //     if (response?.data) {
    //       convertToBlob(response.data);
    //     }
    //   }
    // },
    async onSubmitRequestHandler() {
      if (this.itemId) {
        const isValid = await this.validateAllSteps(false);
        if (!isValid) return;

        const answer = await this.ShowCancelModal(
          i18n.t('ucMessagebox.TitleText').toUpperCase(),
          i18n.t('question-save-modal-title'),
          i18n.t('modal-yes-text'),
          i18n.t('btnCancel.Text')
        );

        if (answer) {
          let saveRequest = await this.onSave();
          if (!saveRequest) return;

          const { data: saveResponse } = await _submitRequest(
            this.itemId
          ).catch((error) => {
            this.ShowToast('', error.response.data.message, 'error');
          });

          if (saveResponse) {
            this.ShowToast(
              i18n.t('ProcessSuccessfully'),
              i18n.t('success-modal-title'),
              'success'
            );
            this.tabId = 0; // Move to first tab
            await this.getRequestInfo();

            // Show rating survey
            this.onOpenRatingSurveyModal();
          }
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/components/action-button/index.scss';
@import '@/scss/bootstrap/_colors.scss';
@import '~vue2-editor/dist/vue2-editor.css';

.icon-view-size ::v-deep {
  width: auto !important;

  .dot {
    width: 35px !important;
    height: 35px !important;

    .title-icon {
      font-size: 15px !important;
    }
  }
}
</style>
